/**
 * Build a Socket.IO namespace URL from build-time SOCKET_IO (DefinePlugin).
 * socket.io-client expects an http(s) origin; ws(s) and bare host:port are normalized.
 */

export function normalizeSocketBaseUrl(raw) {
  if (!raw || typeof raw !== "string") return "";
  const v = raw.trim();
  if (!v) return "";
  if (v.startsWith("ws://")) return `http://${v.slice("ws://".length)}`;
  if (v.startsWith("wss://")) return `https://${v.slice("wss://".length)}`;
  return v;
}

/**
 * @param {string} namespacePath - e.g. "/report-event"
 * @returns {string|null}
 */
export function resolveSocketIoNamespaceUrl(namespacePath) {
  const raw = process.env.SOCKET_IO;
  if (!raw || typeof raw !== "string") return null;
  const base = normalizeSocketBaseUrl(String(raw).trim());
  if (!base) return null;
  const path = namespacePath.startsWith("/") ? namespacePath : `/${namespacePath}`;
  try {
    const withScheme = base.includes("://") ? base : `http://${base}`;
    const u = new URL(withScheme);
    return `${u.origin.replace(/\/$/, "")}${path}`;
  } catch {
    return null;
  }
}
